import Button from "../Button/Button";
import style from "./SuccessScreen.module.css";

export default function SuccessScreen() {
  return (
    <div className={style.container}>
      <div className={style.title}>
        Good luck!
        <br />
        Your application has been submitted.
      </div>
      <div className={style.content}>
        <p>
          <b>What happens next?</b>
        </p>
        <p>
          We'll review your application and get back to you with our decision on
          whether or not we'll be taking you to the next stage.{" "}
          <b>
            One of our recruiters will be in touch to explain the next steps if
            moving forward.
          </b>
        </p>
        <p>
          If you are unsuccessful, we'll let you know by email. You can expect
          to hear back from us within 1 week normally. If you haven’t heard from
          us by then, please check your junk folder.
        </p>
        <p>
          Last but not least, we believe in fostering a diverse and inclusive
          workplace. Therefore, we want to make sure that our recruitment
          process is accessible to everyone. So if you need any reasonable
          adjustments at any point in the process just let your recruiter know
          what you need and we'll do our best to help.
        </p>
        <p>
          <b>
            We really appreciate your interest in Shapr3D and the time you took
            to fill this in.
          </b>
        </p>
        <div className={style.buttonContainer}>
          <Button variant="secondary" onClick={() => window.location.reload()}>
            Back to application
          </Button>
          <Button
            variant="secondary"
            onClick={() =>
              (window.location.href = "https://www.shapr3d.com/careers")
            }
          >
            View more jobs at Shapr3D
          </Button>
        </div>
      </div>
    </div>
  );
}
